module.exports = __webpack_public_path__ + "img/ditu.0916f080.png";